import { render, staticRenderFns } from "./fireResistantStructSpecPid.vue?vue&type=template&id=61c3261a"
import script from "./fireResistantStructSpecPid.vue?vue&type=script&lang=js"
export * from "./fireResistantStructSpecPid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61c3261a')) {
      api.createRecord('61c3261a', component.options)
    } else {
      api.reload('61c3261a', component.options)
    }
    module.hot.accept("./fireResistantStructSpecPid.vue?vue&type=template&id=61c3261a", function () {
      api.rerender('61c3261a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/frss/fireResistantStructSpecPid.vue"
export default component.exports